module.exports = __webpack_public_path__ + "img/profilePicture.1db5fa59.jpg";